// src/App.tsx
import React, { useEffect, useState } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';

import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import TodayEntryModal from './components/TodayEntryModal';

// Import the theme
import './styles/theme.css';
import './App.css';  // Keep your existing App.css

function App() {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const [showEntryModal, setShowEntryModal] = useState(false);
  const [refreshKey, setRefreshKey] = useState(0);

  useEffect(() => {
    const token = localStorage.getItem('flab2fabs_token');
    setIsAuthenticated(!!token);
    setIsLoading(false);
  }, []);

  const handleLoginSuccess = () => setIsAuthenticated(true);

  const handleWorkoutSaved = () => {
    setShowEntryModal(false);
    setRefreshKey((k) => k + 1); // 🔥 force dashboard reload
  };

  if (isLoading) return <div>Loading…</div>;

  return (
    <Router>
      <Routes>
        <Route
          path="/login"
          element={
            isAuthenticated ? (
              <Navigate to="/dashboard" replace />
            ) : (
              <Login onLoginSuccess={handleLoginSuccess} />
            )
          }
        />

        <Route
          path="/dashboard"
          element={
            isAuthenticated ? (
              <>
                <Dashboard
                  onLogWorkout={() => setShowEntryModal(true)}
                  refreshKey={refreshKey}
                />
                <TodayEntryModal
                  isOpen={showEntryModal}
                  onClose={() => setShowEntryModal(false)}
                  onSave={handleWorkoutSaved}
                />
              </>
            ) : (
              <Navigate to="/login" replace />
            )
          }
        />

        <Route path="*" element={<Navigate to="/dashboard" replace />} />
      </Routes>
    </Router>
  );
}

export default App;
